import { Get, Post } from "./common";

export default class VerificationRequestService {
  static create = async (token: string) =>
    await Post({ path: "verifications", token });

  static getMine = async (token: string) =>
    await Get({ path: "verifications/mine", token });
}
